import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { Skeleton, Grid } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { UPLOADS } from '../../params';
import { getPostsId, getPostsList } from '../../API/posts';
import { Error404_Component } from "../errors/404";
import { setPosts_id } from "../../redux/posts/reducer";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

import edjsParser from '@clefermy/editorjs-parser';
const parser = new edjsParser();
import parse from 'html-react-parser';
const { useBreakpoint } = Grid;

export const Article = props => {
    
    const screens = useBreakpoint();
    const dispatch = useDispatch();
    const location = useLocation();
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const posts = useSelector(state => state.posts);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

        }
    }, []);

    useEffect(async () => {
        await component_start();
    }, [location]);

    async function component_start() {
        
        dispatch(setPosts_id({}));

        await getPostsId({
            id: params.postID,
            category: 'articles'
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getPostsId]`, `color: #A366FF`, json );

            if (json?.code) {
                if (json?.result) {
                    //Done
                }
            }
        });

        await getPostsList({
            category: 14
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getPostsList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    var obj = {
        get posts_list () {
            if ( posts.posts_list.length > 0 ) {
                return posts.posts_list.filter( function( item ) {
                    return(
                        item['id'] !== params.postID
                    );
                } ).slice(0, 4);
            } else {
                return posts.posts_list.slice(0, 4);
            }
        },
    };

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                Object.keys(posts.posts_id).length > 0 ?
                posts.posts_id.error_code === 404 ?
                        <Error404_Component />
                    :
                    <>
                        <Helmet>
                            <title>{ posts.posts_id.seo_title } - Медицинский портал Узбекистана: информация о врачах и учреждениях здравоохранения</title>
                            <meta property='og:title' content={`${ posts.posts_id.seo_title } - Медицинский портал Узбекистана: информация о врачах и учреждениях здравоохранения`} />
                            <meta name="description" content={`${ posts.posts_id.seo_description !== null ? posts.posts_id.seo_description : '' }`} />
                            <meta name="og:description" content={`${ posts.posts_id.seo_description !== null ? posts.posts_id.seo_description : '' }`} />
                            <meta name="keywords" content={`${ posts.posts_id.seo_keywords !== null ? posts.posts_id.seo_keywords : '' }`} />
                        </Helmet>
                        <section className='container_full --article'>
                            <section className='top'>
                                <section className='container shadow default_padding'>
                                    <h1>{posts.posts_id?.title}</h1>
                                </section>
                            </section>
                            <section className='body'>
                                <section className='container shadow default_padding'>
                                    <section className='left'>
                                        {obj.posts_list ? 
                                            <>
                                                <div className='slider_pc'>
                                                {
                                                    obj.posts_list.map((item) => 
                                                        <Link to={`/articles/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                            <div className='article_background'>
                                                                {item.photo_mini === null ? 
                                                                    null
                                                                :
                                                                    <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                }
                                                            </div>
                                                            <div className='article_column'>
                                                                <div className='article_column_left'>
                                                                    <div className='article_title'>{item?.title}</div>
                                                                    <div className='article_excerpt'>{item?.excerpt}</div>
                                                                </div>
                                                                <div className='article_column_right'>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    )
                                                }
                                                </div>
                                                <div className='slider_mob'>
                                                    <Swiper
                                                        loop
                                                        spaceBetween={12}
                                                        slidesPerView={1.5}
                                                        pagination={{
                                                            type: "progressbar",
                                                        }}
                                                        navigation={{
                                                            prevEl: navigationPrevRef.current,
                                                            nextEl: navigationNextRef.current,
                                                        }}
                                                        onBeforeInit={(swiper) => {
                                                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                            swiper.params.navigation.nextEl = navigationNextRef.current;
                                                        }}
                                                        breakpoints={{
                                                            992: {
                                                                slidesPerView: 2.75,
                                                            },
                                                            991: {
                                                                slidesPerView: 2,
                                                            },
                                                            700: {
                                                                slidesPerView: 1.5,
                                                            },
                                                        }}
                                                    >
                                                        {
                                                            obj.posts_list.map((item) => 
                                                                <SwiperSlide>
                                                                    <Link to={`/articles/${item?.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                                        <div className='article_background'>
                                                                            {item.photo_mini === null ? 
                                                                                null
                                                                            :
                                                                                <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                            }
                                                                        </div>
                                                                        <div className='article_column'>
                                                                            <div className='article_column_left'>
                                                                                <div className='article_title'>{item?.title}</div>
                                                                                <div className='article_excerpt'>{item?.excerpt}</div>
                                                                            </div>
                                                                            <div className='article_column_right'>
                                                                                <span></span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </SwiperSlide>
                                                            )
                                                        }
                                                    </Swiper>
                                                </div>
                                            </>
                                        :
                                            <div className='article'>
                                                <div className='article_column'>
                                                    <div className='article_column_left'>
                                                        <div className='article_title'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '200px'}} size="small" shape="round" active block /></div>
                                                        <div className='article_excerpt'><Skeleton.Button style={{marginBottom: '5px', maxWidth: '150px'}} size="small" shape="round" active block /></div>
                                                    </div>
                                                    <div className='article_column_right'>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </section>
                                    <section className='right'>
                                        <div className='content'>
                                            <div className='header'>
                                                {posts.posts_id?.photo_big === null ?
                                                    null
                                                :
                                                    <div className='posts_image_big'>
                                                        <img src={`${UPLOADS}/${posts.posts_id?.photo_big}`} />
                                                    </div>
                                                }
                                            </div>

                                            <div className='body'>
                                                {posts.posts_id?.content !== '{}' ?
                                                    Object.keys(JSON.parse(posts.posts_id?.content)).length > 0 ?
                                                        JSON.parse(posts.posts_id?.content)?.blocks.length > 0 ?
                                                            <div className='text_content'>
                                                                {parse(parser.parse(JSON.parse(posts.posts_id?.content)))}
                                                            </div>
                                                        :
                                                            null
                                                    :
                                                        null
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </section>
                                </section>
                            </section>
                        </section>
                    </>
                :
                    <section className='container shadow default_padding marginTop'>
                        <div className='content'>
                            <Skeleton active />
                        </div>
                    </section>
            }
        </>
    );
};